module.exports = __webpack_public_path__ + "static/start-082799e145996b3dd4530b0a5cc34f2f.png";